import * as React from 'react';
import * as moment from 'moment';
import { DatePicker } from 'antd';
import * as intl from "react-intl-universal";
import StaticView from './StaticView';
import languages from "../../../i18n/utils/languages";

type CUSTOM = 'LONGTERM';

export default class DatePickerField extends React.Component<any, any> {
    static fieldName = 'date';
    public static defaultProps = {
        size: 'large',
        showToday: false,
        format: 'YYYY-MM-DD'
    };

    constructor(props: any) {
        super(props);
        this.state = {
            pickerOpen: false,
            isCustom: false,
            value: null
        };
    }

    costomIntl: { [key in CUSTOM]: string } = {
        'LONGTERM': intl.get('SignUp.LongTermEffective') // 长期有效
    };

    componentWillReceiveProps({ value }: { value: string }) {
        const { customKey } = this.props;
        if (value !== this.props.value) this.setState({
            value,
            isCustom: customKey && value && value === customKey
        });
    }

    componentDidMount() {
        const { customKey, value } = this.props;
        if (customKey && value && value === customKey) {
            this.setState({
                value: customKey,
                isCustom: true,
            });
        } else {
            value && this.setState({ value });
        }
    }

    /**
     * 自定义值处理
     */
    customHandle = () => {
        const { onChange, customKey } = this.props;
        onChange(customKey);
        this.setState({
            isCustom: true,
            pickerOpen: false,
        });
    }

    /**
     * 静态值处理
     */
    staticHandle = () => {
        const { value } = this.props;
        return value
            ? this.costomIntl[value as CUSTOM]
                ? this.costomIntl[value as CUSTOM]
                : value
            : '-';
    }

    render() {
        // 配置国际化语言(moment的locale未正确设置会导致部分语言错乱)
        moment.locale(languages.getLocale());
        const { isCustom, value, pickerOpen } = this.state;
        const { onChange, disabled, size, showToday, showTime, disabledDate, disabledTime, format, staticView, dropdownClassName, customKey } = this.props;
        const customText = this.costomIntl[customKey as CUSTOM];
        const timeValue = value
            ? value === customKey
                ? moment()
                : moment(value)
            : value;
        return ((staticView && disabled)
            ? <StaticView display={this.staticHandle()}/>
            : <div className='DatePick-Wrapper' style={{position: 'relative'}}>
                {isCustom && <p className='CustomValue' onClick={() => this.setState({ pickerOpen: true })}>{customText}</p>}
                <DatePicker {...{
                    'data-__meta': this.props['data-__meta'],
                    defaultValue: timeValue,
                    value: timeValue,
                    disabled: !!disabled,
                    size: size,
                    showToday: showToday,
                    showTime: showTime,
                    disabledDate: disabledDate,
                    className: 'ant-calendar-picker',
                    dropdownClassName,
                    ...(customText ? {
                        renderExtraFooter: () => <p style={{textAlign: 'center', cursor: 'pointer'}} onClick={this.customHandle}>{customText}</p>
                    }: {}),
                    ...(isCustom ? {
                        open: pickerOpen,
                    }: {}),
                    placeholder: intl.get('Hint.Select', { field: intl.get('Global.Date') }),
                    disabledTime: disabledTime && value && moment(value).date() == moment().date() ? disabledTime : () => {
                        return {
                            disabledHours: (): any => [],
                            disabledMinutes: (): any => [],
                            disabledSeconds: (): any => []
                        };
                    },
                    format: format,
                    onChange: (date: any, dateString: string) => {
                        this.setState({ isCustom: false });
                        onChange(dateString || date ? date.format(this.props.format) : '');
                    }
                }}
                onOpenChange={(status: Boolean) => {
                    this.setState({ pickerOpen: status });
                }}
                popupStyle={{ zIndex: 1050 }}
            />
        </div>
        );
    }
}
